import { render, staticRenderFns } from "./LogisticsDistribution.vue?vue&type=template&id=fd89b312&scoped=true"
import script from "./LogisticsDistribution.vue?vue&type=script&lang=js"
export * from "./LogisticsDistribution.vue?vue&type=script&lang=js"
import style0 from "./LogisticsDistribution.vue?vue&type=style&index=0&id=fd89b312&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd89b312",
  null
  
)

export default component.exports